import { Buffer } from 'buffer';
import { Permission, PermissionKey, Scope } from './E2ClientProvider.types';

/**
 * Decode JWT token and return the claims
 * Since the E2 backend verify the token, This E2 frontend does not verify it.
 *
 * @param token
 * @returns {object} JWT claims
 */
export const decodeClaims = (token: string) => JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());

/**
 * Get the value by the scope from the JWT token
 *
 * @param scope {Scope} scope of the permission
 * @param perm {Permission} perm object from the JWT token
 * @returns {string} value of the permission
 */
export const getIdByScope = (scope: Scope, perm: Permission) => {
  const targetKey = Object.keys(perm).find((key) => {
    return key.split(':')[1] === scope;
  }) as PermissionKey;

  if (!targetKey) throw new Error('Invalid permission');

  const value = perm[targetKey];

  return value;
};
